






import SideNavigation from "@/components/SideNavigation.vue";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component({
	components: {
		"side-nav": SideNavigation,
	},
})
export default class App extends Vue {
	public showSideNav: boolean = false;

	sideNavToggleValueChanged(toggledValue: boolean) {
		this.showSideNav = toggledValue;
	}
}
